import { isMobileOnly } from 'react-device-detect';
import LoanPageListLoanDesktop from './LoansDesktop/LoanPageListLoanDesktop';
import LoanPageListLoanMobile from './LoansMobile/LoanPageListLoanMobile';

const LoanswitchPCorMobileList = ({ }) => {
	return <>{isMobileOnly ? <LoanPageListLoanMobile /> : <LoanPageListLoanDesktop />}</>;
};

export default LoanswitchPCorMobileList;
